import styled from "styled-components";

import Box from "./desktopBox";

const IconBox = styled(Box)({
  alignItems: "center",
  justifyContent: "center",
  marginBottom: 20,
});

export default IconBox;
